import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form/immutable.js';

import app from './app/index.js';
import ui from './ui/index.js';
import auth from './auth/index.js';
import organizations from './organizations/index.js';
import users from './users/index.js';
import reports from './reports/index.js';
import author from './author/index.js';


export default combineReducers({
    form: formReducer,
    router: routerReducer,
    app,
    ui,
    auth,
    organizations,
    users,
    reports,
    author,
});
